import CONSTANTS from '@/constants'
import { ISubscriptionsState } from '@/@types'

const state: ISubscriptionsState = {
  currentSubscriptions: [],
  currentInvoices: [],
  passTypes: [],
  manageablePassStates: CONSTANTS.SUBSCRIPTIONS.MANAGEABLE_STATES,
  addTermPricing: {},
  availablePlans: [],
  planDetails: [
    {
      name: 'Free eJPT and ICCA Voucher',
      checked: [CONSTANTS.PLANS.ANNUAL],
      unchecked: [CONSTANTS.PLANS.MONTHLY],
    },
    {
      name:
        "Access to INE's Introductory Learning Paths including Pentester Student, CCNA, and Cloud Foundations",
      checked: [CONSTANTS.PLANS.MONTHLY, CONSTANTS.PLANS.ANNUAL],
      unchecked: [],
    },
    {
      name: 'Github and Azure projects for intro courses',
      checked: [CONSTANTS.PLANS.MONTHLY, CONSTANTS.PLANS.ANNUAL],
      unchecked: [],
    },
    {
      name: 'Access entire course library',
      checked: [CONSTANTS.PLANS.PREMIUM],
      unchecked: [],
    },
    {
      name: 'Github and Azure projects',
      checked: [CONSTANTS.PLANS.PREMIUM],
      unchecked: [],
    },
    {
      name: 'Hands-on Labs',
      checked: [CONSTANTS.PLANS.ANNUAL, CONSTANTS.PLANS.PREMIUM],
      unchecked: [],
    },
    {
      name: 'Live Online Bootcamps',
      checked: [CONSTANTS.PLANS.PREMIUM],
      unchecked: [],
    },
    {
      name: 'Networking Workbooks',
      checked: [CONSTANTS.PLANS.PREMIUM],
      unchecked: [],
    },
    {
      name: 'Everything in Premium',
      checked: [CONSTANTS.PLANS.PREMIUM_PLANS[3]],
      unchecked: [],
    },
    {
      name: 'Access to PentesterAcademy ($249 value)',
      checked: [CONSTANTS.PLANS.PREMIUM_PLANS[3]],
      unchecked: [],
    },
  ],
  currentPlanComparison: {},
  newPlanCodes: [
    CONSTANTS.PLANS.PREMIUM,
    CONSTANTS.PLANS.ANNUAL,
    CONSTANTS.PLANS.MONTHLY,
    ...CONSTANTS.PLANS.BUSINESS.map(p => p),
  ],
  premiumPlanCode: CONSTANTS.PLANS.PREMIUM,
  paymentInfo: {
    last4_of_cc: '',
    account_credit: '$0',
    payment_method: '',
  },
  cancellationFields: {},
  promotionsAvailable: {},
  addYearPromoEnabled: false,
  currentPromotionContext: '',
}

export default state
